"use client";

import { createContext } from "react";

import type {
  BasNavigationStateRecord,
  NavigationStateRecord,
  NavigationState,
  NavigationStateKey,
} from "@huub-web/ui";
import type {
  MenuVariant,
  SideContentVariant,
} from "./NavigationStateProvider";

export type NavigationContext = NavigationStateKey[];
export type NavigationalPathMap = { [key: NavigationStateKey]: string };

export type NavigationStateState = {
  navigationState: NavigationState;
  navigationContext: NavigationContext;
  currentPath?: string;
  navigationalPathMap: NavigationalPathMap;

  menuVariant: MenuVariant;
  sideContentVariant: SideContentVariant;

  activeNavigationRecord: NavigationStateRecord | undefined;
  activeNavigationRecords: BasNavigationStateRecord[] | undefined;

  setNavigationState: (...keys: NavigationStateKey[]) => void;
  getNavigationPath: (...keys: NavigationStateKey[]) => string | null;

  isMenuOpen: boolean;
  toggleMenu: () => void;
  setMenuOpen: (open: boolean) => void;

  isSideContentOpen: boolean;
  setSideContentOpen: (open: boolean) => void;
};

export const NavigationStateContext = createContext<
  NavigationStateState | undefined
>(undefined);
